import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax

Vue.use(Vuesax)
// axios
import axios from "axios"
Vue.prototype.$http = axios

// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'

import 'flatpickr/dist/flatpickr.css';

// Vue Router
import router from './Router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
function asyncGetContainer() {
    return new Promise(resolve => {
      const observer = new MutationObserver(function(mutations, me) {
        const myContainer = document.getElementById("app");
        if (myContainer) {
          me.disconnect();
          resolve(myContainer);
        }
      });
      observer.observe(document, {
        childList: true,
        subtree: true
      });
    });
}
const options = {
    position: "bottom-right",
    transition: "Vue-Toastification__bounce",
    maxToasts: 20,
    newestOnTop: true,
    container: asyncGetContainer
};

Vue.use(Toast, options);


Vue.config.productionTip = false
const app = new Vue({
    router,
    store,
    render: h => h(App)
})
app.$mount('#app')
